<template>
  <div class="auth-wrapper auth-v1 px-2 ">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- Brand logo-->
        <section class="brand-logo">
          <b-img :src="LogoFondoClaro"/>
        </section>
        <!-- /Brand logo-->
        <b-card-title class="mb-1 text-center">
          {{ $t('Establecer la contraseña') }}🔒
        </b-card-title>


        <!-- form -->
          <b-form method="POST" class="auth-reset-password-form mt-2" @submit.prevent="enviar">

            <!-- password -->
            <b-form-group :label="$t('Nueva contraseña')" label-for="reset-password-new">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null">

                  <b-form-input id="reset-password-new" v-model="password" v-bind="passwordProps" :type="passwordFieldType"
                    :state="!errors.password" class="form-control-merge" name="reset-password-new"
                    placeholder="············" />

                    <b-input-group-text>
                       <font-awesome-icon :icon="['fas', passwordToggleIcon]" @click="togglePasswordVisibility()" />
                    </b-input-group-text>
                </b-input-group>
                <small class="text-danger">{{ errors.password }}</small>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group label-for="reset-password-confirm" :label="$t('Confirmar Contraseña')">

                <b-input-group class="input-group-merge" >
                  <b-form-input id="reset-password-confirm" v-model="cPassword" v-bind="cPasswordProps" :type="passwordFieldType"
                    class="form-control-merge" :state="!errors.cPasswordProps" name="reset-password-confirm"
                    placeholder="············" />

                     <b-input-group-text>
                        <font-awesome-icon :icon="['fas', passwordToggleIcon]" @click="togglePasswordVisibility()" />
                    </b-input-group-text>
               
                </b-input-group>

                <small class="text-danger">{{ errors.cPassword }}</small>

            </b-form-group>

            <!-- submit button -->
            <b-button  type="submit" variant="primary" v-loading="loading" :disabled="loading" class="mt-1 w-100">
              {{ $t('Establecer nueva contraseña') }}
            </b-button>
          </b-form>

        <p class="text-center mt-2">
          <b-link :to="{name:'login'}">
            <font-awesome-icon icon="chevron-left" size="lg" />
            {{ $t('Volver al login') }}
          </b-link>
        </p>

      </b-card>

    </div>
  </div>

</template >

<script setup>
import { useForm } from 'vee-validate'
import { required,password as passwordV,confirmed } from '@validations'
import  { useTogglePasswordVisibility } from '@composables/useTogglePasswordVisibility'; 
import useAppConfigStore from '@/store/app-config';
import useRootStore from '@/store/root';




import router from '@/router';

const props = defineProps(['usuario']);
import LogoFondoClaro from '@images/logos/logo_fondo_claro.png'
const password1FieldType = ref('password');
const password2FieldType = ref('password');
const simpleRules = ref(null);

const app_config_store = useAppConfigStore();
const root_store = useRootStore();

const initialsValues = ref({
  password:'',
  cPassword:''
});

const {defineField,errors,setErrors,handleSubmit} = useForm({
  initialsValues,
  validationsSchema:{
    password:[required,passwordV],
    cPassword: [required, (val, ctx) => confirmed(val, ctx.form.password,ctx)]
  }
});

const [password,passwordProps] = defineField('password');
const [cPassword,cPasswordProps] = defineField('cPassword');



const { passwordFieldType, togglePasswordVisibility, passwordToggleIcon } = useTogglePasswordVisibility();

const enviar =  handleSubmit((values) => {

   axios.put(`/api/usuario/${props.usuario}/establecer/contrasena`, {
      password: values.password,
      password_confirmation: values.cPassword
    }).then(({data}) => {

      if (data.result) {
        toast.success(data.status)
        router.push({ name: 'login' })
      } else {
        toast.info(data.status)
      }
    }).catch(e => {
      console.log(e)
    })

});

const { layout } = storeToRefs(app_config_store);
const skin = computed(() => layout.value.skin);
const loading =  computed(() => root_store.loading);

</script>

<style lang="scss" scoped>
// @import '@/assets/scss/vue/pages/page-auth.scss' ;

.auth-inner{
  // background:red;
  max-width:420px !important;
}

.brand-logo{
  img{
    width:200px;
    height:auto;
  }
}
</style>
